<template>
  <form name="contract" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class="row mt-3">
      <div class="col-md-7">
        <div class="form-group">
          <label for="customer_id"
            >Cliente <span v-if="!data.id" class="m--font-danger">*</span></label
          >
          <div class="input-group">
            <SelectCustomers
              ref="customer_id"
              :selected="data.customer_id"
              :first="'Selecione um cliente'"
              @change="data.customer_id = $event"
              :disabled="!!data.id"
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="product_id"></label>
          <div class="clear-link">
            <a
              href="javascript:;"
              id="m_login_forget_password"
              @click="clearDiscounts()"
              class="m-link"
              >Limpar Formulário</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3">
        <div class="form-group">
          <label for="date">Tipo do desconto<span class="m--font-danger"> *</span></label>
          <div class="input-group">
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="typeDiscount"
                  id="typeDiscountSaldo"
                  value="1"
                  @change="changeDiscountTypeValue($event)"
                  v-model="discounts.discount_type"
                  :checked="true"
                />
                Saldo
              </label>
            </div>
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="typeDiscount"
                  id="typeDiscountUnico"
                  value="2"
                  @change="changeDiscountTypeValue($event)"
                  v-model="discounts.discount_type"
                />
                Único
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group">
          <label for="date">Aplicar de</label>
          <div class="input-group">
            <vue-monthly-picker
              inputClass="form-control m-input"
              selectedBackgroundColor="blue"
              dateFormat="MM/YYYY"
              :monthLabels="monthsLabels"
              v-model="discounts.start_date"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="date">Aplicar até</label>
          <div class="input-group">
            <vue-monthly-picker
              inputClass="form-control m-input"
              selectedBackgroundColor="blue"
              dateFormat="MM/YYYY"
              :monthLabels="monthsLabels"
              v-model="discounts.until_date"
            >
            </vue-monthly-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3">
        <div class="form-group">
          <label>Tipo do valor<span class="m--font-danger"> *</span></label>
          <div class="input-group">
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="typeValue"
                  id="typeValueReal"
                  value="1"
                  :disabled="discounts.discount_type == 1"
                  v-model="discounts.is_percentage"
                  @change="changeMaskValue($event)"
                />
                Real
              </label>
            </div>
            <div class="radio">
              <label>
                <input
                  type="radio"
                  name="typeValue"
                  id="typeValuePerc"
                  value="2"
                  :disabled="discounts.discount_type == 1"
                  @change="changeMaskValue($event)"
                  v-model="discounts.is_percentage"
                />
                Percentual
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Valor <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ symbolDiscount }}</span>
            </div>
            <money v-bind="money" class="form-control m-input" v-model="discounts.amount"></money>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Limite Mensal </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">R$</span>
            </div>
            <money
              v-bind="moneyLimit"
              class="form-control m-input"
              v-model="discounts.max_amount"
            ></money>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4">
        <div class="form-group">
          <label for="product_id">Produto <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectProducts
                id="product_id"
                ref="product_id"
                :first="'Selecione um produto'"
                :selected="discounts.product_id"
                @change="updateProductIdValue($event)"
                v-model="discounts.product_id"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="product_id">Motivo <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <div class="input-group">
              <SelectDiscountReasons
                id="reason_id"
                ref="reason_id"
                :first="'Selecione um motivo'"
                :selected="discounts.reason_id"
                @change="updateReasonIdValue($event, discounts)"
                v-model="discounts.reason_id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="row mt-5 mb-3" />

    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.customer_id"
            >O campo <strong>Cliente</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="hasEmptyProductRow()"
            >O campo <strong>Produto</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="hasEmptyReasonRow()"
            >O campo <strong>Motivo</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.customer_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="hasZeroValue()"
            >O campo <strong>Valor</strong> deve ser maior que 0 *</a
          >
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { Money } from 'v-money';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectDiscountReasons from '@/components/forms/SelectDiscountReasons';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';

import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectCustomers from '../forms/SelectCustomers';

const getEmptyDiscount = ({
  discount_type = '1',
  start_date = '',
  until_date = '',
  is_percentage = '1',
  amount = '',
  max_amount = '',
  product_id = '',
  reason_id = '',
}) => ({
  discount_type,
  start_date,
  until_date,
  is_percentage,
  amount,
  max_amount,
  product_id,
  reason_id,
});

export default {
  mixins: [returnMessageFormMixin],
  name: 'DiscountSaveForm',
  components: {
    SelectCustomers,
    SelectProducts,
    Money,
    SelectDiscountReasons,
    VueMonthlyPicker,
  },
  data() {
    return {
      data: {},
      discounts: getEmptyDiscount({ date: moment().format('YYYY-MM') }),
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        total: '',
      },
      moneyLimit: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        total: '',
      },
      symbolDiscount: 'R$',
      reasons: [],
      monthsLabels: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
    };
  },
  methods: {
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const data = {
        customer_id: this.data.customer_id,
        discounts: this.discounts,
      };

      const url = `${baseApiUrl}/v1/customer/discounts/create-multiple`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
        })
        .catch((error) => {
          console.log(error);
          this.logMessageFormFailed(error.response);
        });
    },
    updateProductIdValue(product_id) {
      this.discounts.product_id = product_id;
    },
    updateReasonIdValue(reason_id) {
      this.discounts.reason_id = reason_id;
    },
    callData() {
      this.getCustomersWithDiscounts();
    },
    clearDiscounts() {
      this.discounts = getEmptyDiscount({ date: moment().format('YYYY-MM') });
      this.data.customer_id = 0;
    },
    hasEmptyProductRow() {
      let hasEmpty = false;
      if (this.discounts.product_id === '') {
        hasEmpty = true;
      }
      return hasEmpty;
    },
    hasEmptyReasonRow() {
      let hasEmpty = false;
      if (this.discounts.reason_id === '') {
        hasEmpty = true;
      }
      return hasEmpty;
    },
    hasZeroValue() {
      let hasZero = false;
      if (this.discounts.amount <= 0) {
        hasZero = true;
      }
      return hasZero;
    },
    changeMaskValue() {
      this.money = {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        total: '',
      };

      this.symbolDiscount = 'R$';

      if (this.discounts.is_percentage === '2') {
        this.money = {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: ' %',
          precision: 2,
          masked: false,
          total: '',
        };
        this.symbolDiscount = '%';
      }
    },
    changeDiscountTypeValue() {
      if (this.discounts.discount_type == 1) {
        this.discounts.is_percentage = 1;
        this.changeMaskValue();
      }
    },
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
    formIsValid() {
      if (
        this.data.customer_id &&
        !this.hasEmptyProductRow() &&
        !this.hasEmptyReasonRow() &&
        !this.hasZeroValue()
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.contractId && this.contractId != 'add') {
      this.callData();
    } else {
      this.data = {
        customer_id: 0,
        product_id: 0,
        due_day: '',
        start: '',
      };
    }
  },
};
</script>

<style scoped>
.clear-link {
  margin-top: 18px;
}
.btn-collapse {
  border-color: transparent;
  margin-top: 5px;
}
.radio {
  margin: auto;
}
</style>
